// @ts-check
import React from 'react';
import { Grid, Typography } from '@material-ui/core';
import Form from '../../../../../form';
import { Field } from 'react-final-form';
import Icon from '../../../../Icon';

var RelationshipDialog = function RelationshipDialog(_ref) {
  var onSubmit = _ref.onSubmit,
      onRemove = _ref.onRemove,
      onClose = _ref.onClose,
      tables = _ref.tables,
      values = _ref.values;
  var tablesOptions = tables.map(function (table) {
    return {
      value: table.id,
      label: table.name
    };
  });

  var getDimensionsOptions = function getDimensionsOptions(tableId) {
    if (!tableId) return [];
    var table = tables.find(function (currentTable) {
      return currentTable.id === tableId;
    });
    return table.dimensions.map(function (dimension) {
      return {
        label: dimension.name,
        value: dimension.id
      };
    });
  };

  var handleValidation = function handleValidation(data) {
    var error = {
      destinationTable: data.sourceTable === data.destinationTable ? 'Source and related must not be the same table' : undefined
    };
    if (!data.sourceTable) error.sourceTable = 'Required';
    if (!data.sourceColumn) error.sourceColumn = 'Required';
    if (!data.destinationTable) error.destinationTable = 'Required';
    if (!data.destinationColumn) error.destinationColumn = 'Required';
    return error;
  };

  return React.createElement(Form.Dialog, {
    onSuccess: function onSuccess(relationship) {
      onSubmit(relationship);
      onClose();
    },
    windowProps: {
      onClose: onClose,
      style: {
        width: 600
      },
      header: values === undefined ? 'Add Relationship' : 'Edit Relationship'
    },
    defaultValue: values,
    onValidate: handleValidation,
    submitLabel: "OK",
    labelPlacement: "top",
    variant: "filled",
    onCancel: onClose,
    renderFooterLeft: function renderFooterLeft() {
      return values !== undefined && React.createElement(Icon, {
        onClick: onRemove,
        labelPlacement: "end",
        type: "delete",
        label: "Delete Relationship"
      });
    },
    renderContent: function renderContent() {
      return React.createElement(Grid, {
        container: true,
        style: {
          minHeight: 300
        },
        alignContent: "flex-start"
      }, React.createElement(Grid, {
        item: true
      }, React.createElement(Typography, {
        gutterBottom: true
      }, "Select the related objects and their coresponding keys.")), tablesOptions.length > 1 ? React.createElement(React.Fragment, null, React.createElement(Grid, {
        item: true,
        container: true,
        spacing: 2
      }, React.createElement(Grid, {
        item: true,
        xs: 7
      }, React.createElement(Form.Fields.MultiSelect, {
        required: true,
        label: "Source",
        name: "sourceTable",
        options: tablesOptions
      })), React.createElement(Grid, {
        item: true,
        xs: 5
      }, React.createElement(Field, {
        name: "sourceTable"
      }, function (e) {
        return React.createElement(Form.Fields.MultiSelect, {
          required: true,
          key: e.input.value,
          label: "Primary Key",
          name: "sourceColumn",
          options: getDimensionsOptions(e.input.value)
        });
      }))), React.createElement(Grid, {
        item: true,
        container: true,
        spacing: 2
      }, React.createElement(Grid, {
        item: true,
        xs: 7
      }, React.createElement(Form.Fields.MultiSelect, {
        required: true,
        label: "Related",
        name: "destinationTable",
        options: tablesOptions
      })), React.createElement(Grid, {
        item: true,
        xs: 5
      }, React.createElement(Field, {
        name: "destinationTable"
      }, function (e) {
        return React.createElement(Form.Fields.MultiSelect, {
          required: true,
          key: e.input.value,
          label: "Foreign Key",
          name: "destinationColumn",
          options: getDimensionsOptions(e.input.value)
        });
      })))) : React.createElement(Grid, {
        item: true
      }, React.createElement(Typography, {
        color: "error"
      }, "There should be at least two tables to define a relationship.")));
    }
  });
};

export default RelationshipDialog;